export enum SnackbarSeverity {
  'info' = 'info',
  'success' = 'success',
  'warning' = 'warning',
  'error' = 'error',
}
